// @flow
import React, { Component } from "react";
import moment from "moment";
import Highlighter from "react-highlight-words";
import tz from "moment-timezone";
import I18n from "../../../../i18n/I18n";
import { Button, LocaleLink, Status, Icon } from "../../../common/";
import { DisputeModal } from "../../";
import styles from "../../../orders/orderTable/OrderTable.scss";

class TransfersRow extends Component {
  state = {
    dialogOpen: false,
    isPaneOpen: false
  };
  openDialog = () => {
    this.setState({
      dialogOpen: true
    });
  };

  closeDialog = () => {
    this.setState({
      dialogOpen: false
    });
  };

  openModal = () => {
    this.setState({
      isPaneOpen: true
    });
  };
  onCloseModal = () => {
    this.setState({
      isPaneOpen: false
    });
  };
  printCall = () => {
    this.props.printCall(
      this.props.data.asn_nr || this.props.data.partner_rtv_nr,
      this.props.data.partner_rtv_nr ? "rtv" : null,
      this.props.isFbn ? "fbn" : null,
      this.props.data.status
    );
  };
  exportAsn = () => {
    this.props.exportAsn(
      this.props.data.asn_nr || this.props.data.partner_rtv_nr,
      this.props.data.partner_rtv_nr ? "rtv" : null,
      this.props.isFbn ? "fbn" : null,
      this.props.data.status
    );
  };
  render() {
    const {
      lang,
      transfersType,
      data,
      searchString,
      printCall,
      exportAsn,
      isPrintLoading,
      isExportLoading,
      closeAsn,
      isClosing,
      seller,
      property,
      isFbn
    } = this.props;

    const diff = data && !data.is_match;
    return (
      <tr className={styles.row}>
        {property.haveVal("asn_nr") || property.haveVal("partner_rtv_nr") ? (
          <td>
            {data && (data.asn_nr || data.partner_rtv_nr) ? (
              <LocaleLink
                to={`/transfers/${
                  data.partner_rtv_nr
                    ? "rtv"
                    : `${
                        isFbn
                          ? data.status &&
                            data.status.toLowerCase() !== "closed"
                            ? "preview"
                            : "fbn-asn"
                          : "asn"
                      }`
                }/${data.asn_nr || data.partner_rtv_nr}`}
              >
                <Button variant="asn" className={styles.asnBtn}>
                  <Highlighter
                    highlightClassName={styles.highlight}
                    searchWords={[searchString]}
                    autoEscape={true}
                    textToHighlight={data.asn_nr || data.partner_rtv_nr}
                  />
                </Button>
              </LocaleLink>
            ) : (
              ""
            )}
          </td>
        ) : (
          ""
        )}
        {property.haveQtyVal("qty_expected") ? (
          <td>
            <strong>{data.qty_expected}</strong>
          </td>
        ) : (
          ""
        )}
        {property.haveQtyVal("qty_sent") ? (
          <td
            className={
              data.asn_nr
                ? `${styles.qty} ${
                    data.qty_expected !== data.qty_sent ? styles.diff : ""
                  }`
                : ""
            }
          >
            {data.qty_sent}
          </td>
        ) : (
          ""
        )}

        {property.haveQtyVal("qty_recv") ? (
          <td>
            <div
              className={`${styles.qty} ${
                data.qty_recv !== data.qty_sent ? styles.diff : ""
              }`}
            >
              {data.qty_recv}
            </div>
          </td>
        ) : (
          ""
        )}
        {property.haveQtyVal("qty_qcpassed") ||
        // property.haveQtyVal("qty_approved") ||
        // property.haveQtyVal("qty_rejected") ||
        property.haveQtyVal("qty_qcfailed") ||
        property.haveQtyVal("qty_unidentified") ||
        property.haveQtyVal("qty_excess") ? (
          <td>
            <div>
              {I18n.getText("transfers.approved")}
              {": "}
              {/* <strong> {data.qty_approved}</strong> */}
              <strong> {data.qty_qcpassed}</strong>
            </div>
            <div>
              {I18n.getText("transfers.rejected")}
              {": "}
              {/* <strong> {data.qty_rejected}</strong> */}
              <strong> {data.qty_qcfailed}</strong>
            </div>
            <div>
              {I18n.getText("transfers.unidentified")}
              {": "}
              <strong> {data.qty_unidentified}</strong>
            </div>
            {data.qty_excess >= 0 ? (
              <div>
                {I18n.getText("transfers.excess")}
                {": "}
                <strong> {data.qty_excess}</strong>
              </div>
            ) : (
              ""
            )}
          </td>
        ) : (
          ""
        )}
        {property.haveVal("warehouse_code") ? (
          <td>{data.warehouse_code || ""}</td>
        ) : (
          ""
        )}
        {property.haveVal("warehouse_from") ? (
          <td>{data.warehouse_from || ""}</td>
        ) : (
          ""
        )}
        {property.haveVal("warehouse_to") ? (
          <td>{data.warehouse_to || ""}</td>
        ) : (
          ""
        )}

        {property.haveVal("picked_at") ? (
          <td>
            {data && data.picked_at
              ? moment(data.picked_at).format(
                  `YYYY-MM-DD [${lang === "ar" ? "" : "at"}] h:mm:ss a`
                )
              : "-"}
          </td>
        ) : (
          ""
        )}

        {property.haveVal("received_at") ? (
          <td>
            {data && data.received_at
              ? moment(data.received_at).format(
                  `YYYY-MM-DD [${lang === "ar" ? "" : "at"}] h:mm:ss a`
                )
              : "-"}
          </td>
        ) : (
          ""
        )}
        {property.haveVal("shipped_at") ? (
          <td>
            {data.shipped_at
              ? moment(data.shipped_at).format(
                  `YYYY-MM-DD [${lang === "ar" ? "" : "at"}] h:mm:ss a`
                )
              : "-"}
          </td>
        ) : (
          ""
        )}
        {property.haveVal("scheduled_at") ? (
          <td>
            <div>
              {data.scheduled_at
                ? moment(data.scheduled_at).format(`YYYY-MM-DD`)
                : "-"}
              <div>{data.slot}</div>
            </div>
          </td>
        ) : (
          ""
        )}
        {property.haveVal("posted_at") ? (
          <td>
            {data.posted_at
              ? moment(data.posted_at).format(
                  `YYYY-MM-DD [${lang === "ar" ? "" : "at"}] h:mm:ss a`
                )
              : "-"}
          </td>
        ) : (
          ""
        )}

        {property.haveVal("current_skunique") ? (
          <td>{data.current_skunique || ""}</td>
        ) : (
          ""
        )}

        {property.haveVal("zone_code") ? <td>{data.zone_code || "-"}</td> : ""}
        {property.haveVal("status") ? (
          <td>
            <div>
              {data.status ? <Status status={data.status} /> : ""}
              {data.status !== "Complete" &&
              data.status !== "complete" &&
              false &&
              !this.props.isFbn &&
              transfersType === 1 ? (
                <div>
                  <a onClick={this.openModal} className={styles.viewMoreBtn}>
                    {I18n.getText("transfers.open-dispute")}
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
            <DisputeModal
              isPaneOpen={this.state.isPaneOpen}
              onRequestClose={this.onCloseModal}
              currencyCode={seller && seller.currency_code}
              asn={data.asn_nr}
            />
          </td>
        ) : (
          ""
        )}

        <td>
          <span className={styles.btnWrapper}>
            <Button
              variant="transparent"
              className={styles.btnCtr}
              disabled={
                isPrintLoading ||
                (!data.partner_rtv_nr &&
                  data.status !== "Complete" &&
                  data.status !== "scheduled" &&
                  data.status !== "closed" &&
                  data.status !== "processed")
              }
              onClick={() => this.printCall()}
            >
              <Icon name="print" className={styles.printIcon} />
            </Button>
            <div>
              <Button
                variant="transparent"
                className={styles.btnCtr}
                disabled={
                  isPrintLoading ||
                  (!data.partner_rtv_nr &&
                    data.status !== "Complete" &&
                    data.status !== "scheduled" &&
                    data.status !== "closed" &&
                    data.status !== "processed")
                }
                onClick={() => this.exportAsn()}
              >
                <Icon name="download" className={styles.printIcon} />
              </Button>
            </div>
          </span>
          <div>
            {data.status === "Open" &&
            transfersType !== 2 &&
            data.is_pickup_open &&
            seller.can_close_asn ? (
              <Button
                variant="secondary"
                className={styles.button}
                disabled={isClosing || data.status === "Complete"}
                onClick={() => closeAsn(data.id_partner_warehouse, data.id_asn)}
              >
                {isClosing && isClosing.indexOf(data.asn_nr) !== -1 ? (
                  <div className={styles.loader} />
                ) : (
                  I18n.getText("transfers.close-asn")
                )}
              </Button>
            ) : (
              ""
            )}
          </div>
        </td>
      </tr>
    );
  }
}
export default TransfersRow;



// WEBPACK FOOTER //
// ./src/components/transfers/transfersTable/transfersRow/TransfersRow.js